export default __webpack_public_path__ + "images/done_644c97.svg";